/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';

import DegreesModalCta from 'bundles/unified-description-page-common/components/modules/credits/DegreesModalCta';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import { formatPageDataDegrees } from 'bundles/unified-description-page-common/utils/formatPageDataDegrees';

type Props = {
  description?: string;
  degrees?: Array<DegreeFragment> | null;
  disclaimer?: string;
  modalTitle?: string;
  disableCta?: boolean;
};

const EligibleDegreesInfo = ({ description, degrees, disclaimer, modalTitle, disableCta }: Props) => {
  if (!description || !degrees || !degrees.length) {
    return null;
  }

  return (
    <Typography2 component="span" variant="bodyPrimary">
      {description}
      <DegreesModalCta
        modalDescription={<Typography2 component="p">{description}</Typography2>}
        descriptionDisclaimer={disclaimer}
        degrees={formatPageDataDegrees(degrees)}
        modalTitle={modalTitle}
        disableCta={disableCta}
      />
    </Typography2>
  );
};

export default EligibleDegreesInfo;
